module.exports = __webpack_public_path__ + "static/media/ifood.326d94d8.png";